<template>
    <section class="section-style text-center">
        <div class="container"
             data-aos="fade-right"
             data-aos-offset="100"
             data-aos-once="true"
             data-aos-duration="500">
            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md">UJV important documents</h2>
            <div class="row section-explain justify-content-center">
                <div class="col-12 col-sm-6 col-lg-3">
                    <img class="icon" src="/assets/icons/document.svg" height="40" alt="UJV Full Portfolio"/>
                    <h3 class="font-md">UJV Full Portfolio</h3>
                    <a href="/assets/documents/UJV-Hotel-Partner-List-2020.pdf" target="_blank" class="link-style">Open document <i class="material-icons">keyboard_arrow_right</i></a>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <img class="icon" src="/assets/icons/document.svg" height="40" alt="UJV USA Portfolio"/>
                    <h3 class="font-md">UJV USA Portfolio</h3>
                    <a href="/assets/documents/UJV-Hotel-Partners-List-USA.pdf" target="_blank" class="link-style">Open document <i class="material-icons">keyboard_arrow_right</i></a>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <img class="icon" src="/assets/icons/document.svg" height="40" alt="UJV Europe Portfolio"/>
                    <h3 class="font-md">UJV Europe Portfolio</h3>
                    <a href="/assets/documents/UJV-Hotel-Partners-List-Europe.pdf" target="_blank" class="link-style">Open document <i class="material-icons">keyboard_arrow_right</i></a>
                </div>
                <div class="col-12 col-sm-6 col-lg-3">
                    <img class="icon" src="/assets/icons/document.svg" height="40" alt="2021 UJV Brochure"/>
                    <h3 class="font-md">{{ (new Date).getFullYear() }} UJV Brochure</h3>
                    <a href="/assets/documents/Brochure_2021.pdf" class="link-style" target="_blank">Open document <i class="material-icons">keyboard_arrow_right</i></a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

    import AOS from 'aos';
    import 'aos/dist/aos.css';

    AOS.init();

    export default {
        mounted() {

        }
    }

</script>

<style lang="scss" type="text/scss">
    /** Unique Index Styles **/
</style>